import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './component';
import './assets/scss/reset.scss';
import './assets/scss/plugin.scss';
import '@/utils/validate';

import {
  Button,
  PullRefresh,
  List,
  Picker,
  Dialog,
  Popup,
  Empty,
  NavBar,
  Image,
  Icon,
  Calendar,
  Form,
  Field,
  RadioGroup,
  Radio,
  Checkbox,
  CheckboxGroup,
  Skeleton,
  Toast,
  Uploader,
  Loading,
  Tab,
  Tabs,
  ActionSheet
} from 'vant';
Vue.use(Button);
Vue.use(Empty);
Vue.use(Popup);
Vue.use(Picker);
Vue.use(NavBar);
Vue.use(Image);
Vue.use(Icon);
Vue.use(Calendar);
Vue.use(Form);
Vue.use(Field);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(CheckboxGroup);
Vue.use(Checkbox);
Vue.use(Skeleton);
Vue.use(PullRefresh);
Vue.use(List);
Vue.use(Dialog);
Vue.use(Toast);
Vue.use(Uploader);
Vue.use(Loading);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(ActionSheet);

Vue.config.productionTip = false;

// 自适应
const baseSize = 37.5;
function setRem() {
  const scale = document.documentElement.clientWidth / 375;
  document.documentElement.style.fontSize =
    baseSize * Math.min(scale, 2) + 'px';
}
setRem();
window.onresize = function() {
  setRem();
};
new Vue({
  router,
  store,
  render: (h: any) => h(App)
}).$mount('#app');
